<template>
  <div id="blackPlateMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月车管理</el-breadcrumb-item>
          <el-breadcrumb-item>黑名单管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            navigationMap[blackPlateActiveName]
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号码::">
          <el-input placeholder="请输入车牌号码"
                    v-model="fPlateCodeQuery"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="blackPlateListQuery">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addSyncBlackPlate"
                     v-if="is_edit">新增黑名单</el-button>
          <el-button type="primary"
                     size="small"
                     @click="syncAllBlackPlate"
                     v-if="is_syn">批量下发</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="blackPlateActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="黑名单列表"
                     name="blackPlateList">
          <el-row>
            <el-table :data="blackPlateList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="180"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="200"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="150"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注"> </el-table-column>
              <el-table-column fixed="right"
                               align="left"
                               label="操作"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewBlackPlate(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editBlackPlate(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteBlackPlateClient(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synBlackPlate(scope.$index, scope.row, false)"
                             v-if="is_syn && scope.row.fCustTypeID == '0'">上传</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synBlackPlateList">
          <el-row>
            <el-table :data="synBlackPlateList"
                      border
                      v-loading="loading"
                      :row-class-name="tableRowClassName"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="200"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="150"
                               label="加入日期">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="150"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注"> </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewBlackPlate(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editBlackPlate(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteBlackPlateClient(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synBlackPlate(scope.$index, scope.row, true)"
                             v-if="is_syn">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="myBlackPlateEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="cardBlackPlateEditOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="30%">
        <el-form :model="curRowInfo"
                 :rules="rules"
                 ref="form"
                 label-width="100px">
          <el-row>
            <el-col :span="23">
              <el-form-item label="客户::"
                            prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit || curRowInfo.op == 'edit'"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="车牌号码::"
                            prop="fPlateCode">
                <el-input v-model="curRowInfo.fPlateCode"
                          placeholder="请输入车牌号码"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit || curRowInfo.op == 'edit'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="23">
              <el-form-item label="加入时间::"
                            prop="fOpLastTimeStr">
                <el-date-picker style="width: 100%"
                                v-model="curRowInfo.fOpLastTimeStr"
                                :disabled="!curRowInfo.isEdit"
                                type="date"
                                placeholder="选择加入时间"
                                class="cardDateTime"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="23">
              <el-form-item label="备注::">
                <el-input type="textarea"
                          v-model="curRowInfo.fRemark"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="curRowInfo.isEdit">{{ save_msg }}</el-button>
          <el-button @click="cardBlackPlateEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="批量下发"
                 :visible.sync="synDataVisible"
                 width="450px"
                 v-dialogDrag>
        <el-form label-width="100px"
                 :model="syncData"
                 :rules="synRules"
                 ref="ruleForm"
                 style="margin-top:20px">
          <el-form-item label="选择客户::"
                        prop="fCustID">
            <el-select v-model="syncData.fCustID"
                       filterable
                       style="width:250px"
                       placeholder="请选择客户">
              <el-option v-for="item in batchCusts"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="syncAllOk('ruleForm')">确定</el-button>
          <el-button @click="synDataVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'blackPlateMain.vue',
  data () {
    return {
      is_edit: false,
      is_del: false,
      is_syn: false,
      loading: false,
      synDataVisible: false,
      save_loading: false,
      save_msg: '保存',
      curRowInfo: {
        op: '',
        isEdit: false,
        fCustID: '',
        fPlateCode: '',
        // fOpLastTimeStr: '',
        fRemark: '',
        fCustTypeID: ''
      },
      formLabelWidth: '120px',
      cardBlackPlateEditOrDetailVisible: false,
      detailTitle: '',
      blackPlateList: [],
      synBlackPlateList: [],
      choiceCusts: [],
      batchCusts: [],
      selCustID: '',
      fPlateCodeQuery: '',
      navigationMap: {
        blackPlateList: '黑名单列表',
        synBlackPlateList: '待同步'
      },
      tableHeight: 0,
      blackPlateActiveName: 'blackPlateList',
      syncData: {
        fCustID: ''
      },
      synRules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }]
      },
      rules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }],
        fPlateCode: [
          { required: true, message: '请输入车牌号码', trigger: 'blur' },
          { min: 1, max: 59, message: '长度在 1 到 59 个字符', trigger: 'blur' }
        ],
        fOpLastTimeStr: [
          { required: true, message: '请选加入时间', trigger: 'blur' }
        ]
      },
      pageSize: 20,
      pageNo: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup',
      'saveBlackPlate',
      'getBlackPlateByQuery',
      'deleteBlackPlate',
      'synBlackPlateById',
      'getCurrentUserPers'
    ]),
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    blackPlateListQuery () {
      this.initData()
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
    },
    openFun (formName) {
      this.$nextTick(() => {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields()
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // let tmpCust = this.choiceCusts.filter(item => {
          //   if (item.fCustID === this.curRowInfo.fCustID) { return item }
          // })
          // this.curRowInfo.fCustNo = tmpCust[0].fCustNo
          // this.curRowInfo.fCustTypeID = tmpCust[0].fCustTypeID
          // this.curRowInfo.fIsDel = 0
          this.save_loading = true
          this.save_msg = '保存中…'
          this.saveBlackPlate(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status !== 200) {
              this.$message.error('提示：黑名单操作出错')
            } else {
              if (!data.IsOk) {
                this.$message.error(data.Msg)
              } else {
                this.initData()
                this.$message.success(data.Msg)
                this.cardBlackPlateEditOrDetailVisible = false
              }
            }
          })
        } else {
          console.log('userRootGroupMain error submit!!')
          return false
        }
      })
    },
    syncAllBlackPlate () {
      this.syncData.fCustID = ''
      this.synDataVisible = true
    },
    syncAllOk (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.syncData.fCustID) {
              return item
            }
          })
          var isSyn = this.blackPlateActiveName === 'synBlackPlateList'
          var tip =
            '将客户[' +
            tmpCust[0].fCustName +
            ']的【黑名单列表】黑名单，从云平台批量下发同步到线下客户端, 是否继续?'
          var synTip =
            '将客户[' +
            tmpCust[0].fCustName +
            ']的【待同步】黑名单，从云平台批量下发同步到线下客户端, 是否继续?'
          this.$confirm(isSyn ? synTip : tip, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          })
            .then(() => {
              this.synBlackPlateById({
                fCustID: this.syncData.fCustID,
                fIsSyn: isSyn
              }).then(res => {
                if (res && res.data) {
                  let { status, data } = res
                  if (status === 200) {
                    if (data.IsOk) {
                      this.$message({
                        type: 'success',
                        message: '操作完成'
                      })
                      this.synDataVisible = false
                    } else {
                      this.$message.error('提示：' + data.Msg)
                    }
                  }
                }
              })
            })
            .catch(() => { })
        }
      })
    },
    addSyncBlackPlate () {
      this.setDefault()
      this.cardBlackPlateEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.detailTitle = '新增黑白单'
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
    },
    editBlackPlate (index, row) {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate()
      }
      if (row && row !== null && typeof row !== 'undefined') {
        let curRow = {}
        Object.assign(curRow, row)
        this.curRowInfo = curRow
        this.detailTitle = '【' + row.fCustName + '】编辑黑名单'
        this.curRowInfo.isEdit = true
        this.curRowInfo.op = 'edit'
        this.curRowInfo.fIsSyn = this.blackPlateActiveName === 'synBlackPlateList'
        this.cardBlackPlateEditOrDetailVisible = true
      }
    },
    viewBlackPlate (row) {
      this.curRowInfo.isEdit = false
      if (row && row !== null && typeof row !== 'undefined') {
        Object.assign(this.curRowInfo, row)
        this.detailTitle = '【' + row.fCustName + '】查看黑名单'
        this.cardBlackPlateEditOrDetailVisible = true
      }
    },
    deleteBlackPlateClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteBlackPlate({
          fBigRowID: row.fBigRowID,
          fIsSyn: this.blackPlateActiveName === 'synBlackPlateList'
        }).then(res => {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.initData()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      })
    },
    synBlackPlate (index, row, isSyn) {
      if (row && row !== null && typeof row !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm(
          '将客户[' +
          row.fCustName +
          ']的黑名单[' +
          row.fPlateCode +
          ']' +
          msg +
          ', 是否继续?',
          '提示',
          {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }
        )
          .then(() => {
            this.synBlackPlateById({
              fBigRowID: row.fBigRowID,
              fIsSyn: isSyn
            }).then(res => {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.initData()
                } else {
                  this.$message.error('提示：' + data.Msg)
                }
              }
            })
          })
          .catch(() => { })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    initData () {
      var isSyn = this.blackPlateActiveName === 'synBlackPlateList'
      if (isSyn) {
        this.synBlackPlateList = []
      } else {
        this.blackPlateList = []
      }
      this.loading = true
      this.getBlackPlateByQuery({
        fCustID: this.selCustID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        fPlateCode: this.fPlateCodeQuery,
        blackPlateActiveName: this.blackPlateActiveName
      }).then(res => {
        this.loading = false
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.total = data.Data.total
            if (isSyn) {
              this.synBlackPlateList = data.Data.rows || []
            } else {
              this.blackPlateList = data.Data.rows || []
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    }
  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 32000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      let { status, data } = res
      if (status === 200) {
        if (data.IsOk) {
          let custs = []
          Object.assign(custs, data.Data)
          this.choiceCusts = custs
          let tmpCusts = this.choiceCusts.filter(item => {
            if (item.fCustTypeID === '0') {
              return item
            }
          })
          Object.assign(this.batchCusts, tmpCusts)
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
.myBlackPlateEditOrDetail .el-dialog__title {
  color: white;
}
.myBlackPlateEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myBlackPlateEditOrDetail .el-dialog__body {
  padding-bottom: 5px;
}
#blackPlateMain .is-disabled .el-input__inner,
#blackPlateMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#blackPlateMain .warning-row {
  color: chocolate;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/card/blackPlateMain.vue